<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="items"
      :hide-default-header="empty"
      :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
      disable-pagination
      hide-default-footer
      dense
      :show-select="bulkMode"
      v-model="selected"
      style="white-space: nowrap"
    >
    <template v-slot:top>
      <v-toolbar
        v-if="toolbar"
        flat
        dense
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical/>
        <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
        <v-spacer/>
      </v-toolbar>

      <div v-if="showBulk && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
        <v-checkbox
          v-model="bulkMode"
          hide-details
          :disabled="!items.length"
          class="mt-0 pt-0"
        />

        <v-btn
          x-small
          class="ma-2 white--text"
          color="red"
          :disabled="!bulkMode || !deletableCountLocal"
          @click="bulkRemove"
        >
          Bulk Delete
          <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
        </v-btn>
      </div>
    </template>

    <template v-if="!readonly" v-slot:item.actions="{ item }">
      <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
      <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
      <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
      <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
      <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
    </template>
    </v-data-table>

    <r-search-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import { ViewRules } from "@/common/ViewRules";
import { SearchModel } from "@/modules/redactor/models/search/SearchModel";
import RSearchDialog from "@/modules/redactor/views/search/r-search-dialog";

export default {
  name: "r-search-table",
  components: { RSearchDialog },
  props: {
    items: VueTypes.arrayOf(VueTypes.instanceOf(SearchModel)).isRequired,
    title: VueTypes.string.isRequired,
    readonly: VueTypes.bool.def(false),
    toolbar: VueTypes.bool.def(true),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      { text: "Kind", value: "kind.name" },
      { text: "Filter", value: "filter.name" },
      { text: "", value: "actions", width: "100%", sortable: false, align: "end" }
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    empty() { return (this.items || []).length === 0; },

    deletableCountLocal() {
      return this.selected.length;
    },
  },
  methods: {
    normalizePayload(payload) {
      return Array.isArray(payload) ? payload.filter(Boolean) : (payload ? [payload] : []);
    },

    appendMany(list) {
      const arr = this.normalizePayload(list);
      if (arr.length > 0) {
        this.items.push(...arr);
      }
    },

    row_create() {
      this.$refs.dialog.show(ViewRules.CREATE)
        .then(this.appendMany)
        .catch(() => {});
    },

    row_copy(item) {
      const copyItem = item.copy ? item.copy() : (item.clone ? item.clone() : item);
      this.$refs.dialog.show(ViewRules.COPY, copyItem)
        .then(this.appendMany)
        .catch(() => {});
    },

    row_update(item) {
      this.$refs.dialog.show(ViewRules.UPDATE, item.clone ? item.clone() : item)
        .then((result) => {
          const repl = this.normalizePayload(result);
          const idx = this.items.indexOf(item);
          if (idx < 0) return;

          this.items.splice(idx, 1, ...repl);
        })
        .catch(() => {});
    },

    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        if (index >= 0) this.items.splice(index, 1);
      });
    },

    row_moveup(item) {
      const i = this.items.indexOf(item);
      if (i > 0) this.items.splice(i - 1, 2, this.items[i], this.items[i - 1]);
    },

    row_movedown(item) {
      const i = this.items.indexOf(item);
      if (i < this.items.length - 1) this.items.splice(i, 2, this.items[i + 1], this.items[i]);
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          this.selected.forEach(item => {
            const index = this.items.indexOf(item);
            if (index !== -1) {
              this.items.splice(index, 1);
            }
          });
          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    },
  },

  watch: {
    items(newItems) {
      this.selected = this.selected.filter(v => newItems.includes(v));
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
};
</script>